export default {
  play: '立即玩',
  fullscreen: '全屏模式',
  addToFavorites: '添加到收藏',
  removeFromFavorites: '从收藏中移除',
  similarGames: '相似游戏',
  howToPlay: '如何玩',
  gameDescription: '游戏描述',
  controlsAndInstructions: '操作指南',
  share: '分享',
  gameUnavailable: '游戏不可用',
  tryAgainLater: '该游戏当前不可用，请稍后再试。',
  openInNewTab: '在新标签页中打开',
  gameTitle: '游戏标题',
  genres: '游戏类型',
  tags: '标签',
  noGenre: '无类型',
  noTags: '无标签',
  new: '新游戏',
  playAmazingGame: '立即体验这款精彩游戏！',
  noSimilarGames: '没有相似游戏',
  gameNotFound: '游戏未找到',
  gameNotExistOrRemoved: '您查找的游戏不存在或已被移除。',
  backToHome: '返回首页',
  seoTitle: '{title} - 在线游戏 - GoGameVault',
  seoTitleNotFound: '游戏未找到 - GoGameVault',
  seoKeywords: '玩{title}，免费在线游戏，{tags}游戏',
  gameFeatures: '游戏特点',
  controlDetails: '控制详情'
}; 